export default __webpack_public_path__ + "static/media/Background - SAMSUNG.0cb8247f.png";